/* eslint-disable */
export const googleMapsConfig = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['places', 'maps', 'geometry']
}; 